class NewsletterModal {
  constructor() {
    this.modal = document.querySelector('.js-newsletter-modal');
    this.triggers = document.querySelectorAll('.js-newsletter-modal-trigger');
    this.closeButtons = document.querySelectorAll('.js-newsletter-modal-close');
    
    if (this.modal) {
      this.init();
    }
  }

  init() {
    // Bind open triggers
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', () => this.open());
    });

    // Bind close buttons
    this.closeButtons.forEach(button => {
      button.addEventListener('click', () => this.close());
    });

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });

    // Prevent body scroll when modal is open
    this.preventBodyScroll();
  }

  open() {
    this.modal.classList.add('is-active');
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
    
    // Focus the email input
    setTimeout(() => {
      const emailInput = this.modal.querySelector('input[type="email"]');
      if (emailInput) {
        emailInput.focus();
      }
    }, 100);
  }

  close() {
    this.modal.classList.remove('is-active');
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
  }

  isOpen() {
    return this.modal.classList.contains('is-active');
  }

  preventBodyScroll() {
    // Store scroll position and prevent scroll when modal is open
    const style = document.createElement('style');
    style.innerHTML = `
      body.modal-open {
        overflow: hidden;
      }
    `;
    document.head.appendChild(style);
  }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  new NewsletterModal();
});

